import { quoteLineType } from '../../types'
import { DellPriceListItem } from './dellTypes'

export function dellItemToLineItem(
  lineNumber: number,
  _mfgPN: string,
  item: DellPriceListItem,
): Partial<quoteLineType> {
  return {
    LineItemId: crypto.randomUUID(),
    LineNumber: lineNumber,
    Bundle: null,
    Provider: 'Dell',
    Manufacturer: 'Dell',
    MfrPartNumber: item.sku,
    VendorPartNumber: item.sku,
    Description: item.productDescription,
    Qty: 1,
    MSRP: item.retailPrice,
  }
}
